// features/userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface usersState {
  accessToken: string;
  userId: string;
}

const initialState: usersState = {
  accessToken: "",
  userId: "",
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
    },
    setUserId(state, action: PayloadAction<string>) {
      state.userId = action.payload;
    },
  },
});

export const { setAccessToken, setUserId } = usersSlice.actions;
export const usersReducer = usersSlice.reducer;
